import {ContentTop, ContentXsTop, FlexColumn, Gap8, InputContainer} from "../../../../../components/ui/Content";
import {Caption2, FormBottomCaptionContent, Subhead2} from "../../../../../components/Font";
import {InputElement} from "../../../../../ui/Input/Input";
import React, {useEffect, useState} from "react";
import {useTheme} from "styled-components";
import moment from "moment";
import {useAppDispatch, useAppSelector} from "../../../../../app/hooks";
import {cleanError} from "../../api/slice";
import {InputStringError} from "../../../../../components/ui/InputSearch";
import {IPassportInput} from "../ChangePassport";
import {DatePicker} from "../../../../../ui/FormDatePicker/DatePickerSelectors";
import {ICitizenship} from "../../../../../interface/Passport/Account/frontend";


interface IPassportProps {
    onChange(info: IPassportInput): void
    selectedCountry: ICitizenship | null
}

export const Passport = ({onChange, selectedCountry}: IPassportProps) => {
    const Theme = useTheme()
    const dispatch = useAppDispatch()

    const {passport, error} = useAppSelector(state => state.account)
    const [info, setInfo] = useState<IPassportInput>({
        citizenship_id: 0,
        identity_card_type_id: null,
        series: '',
        number: '',
        issued_by: '',
        department_code: '',
        issued_at: null,
    })
    useEffect(() => {
        onChange(info)
    }, [info])

    useEffect(() => {
        if (selectedCountry) {
            setInfo({
                citizenship_id: 0,
                identity_card_type_id: null,
                series: '',
                number: '',
                issued_by: '',
                department_code: '',
                issued_at: null,
            })
        }
    }, [selectedCountry])

    useEffect(() => {
        if (passport) {
            setInfo({
                citizenship_id: passport.citizenship_id,
                identity_card_type_id: passport.identity_card_type_id,
                series: passport.series,
                number: passport.number,
                issued_by: passport.issued_by,
                department_code: passport.department_code,
                issued_at: passport.issued_at,
            })
        } else if (selectedCountry) {
                setInfo({
                    citizenship_id: 0,
                    identity_card_type_id: null,
                    series: '',
                    number: '',
                    issued_by: '',
                    department_code: '',
                    issued_at: null,
                })
            }
    }, [passport, selectedCountry])
    return (
        <>
            <ContentTop>
                <Subhead2>
                    Паспорт РФ
                </Subhead2>
            </ContentTop>
            <ContentTop>
                <Gap8>
                    <FlexColumn>
                        <Caption2 color={Theme.color.secondary}>
                            Серия
                        </Caption2>
                        <ContentXsTop>
                            <InputElement
                                error={error['series']}
                                format={'## ##'}
                                mask={'_'}
                                width={'94px'}
                                value={info.series}
                                onChange={value => {
                                    if (error['series']) {
                                        dispatch(cleanError('series'))
                                    }
                                    setInfo({...info, series: value})
                                }}/>
                        </ContentXsTop>
                    </FlexColumn>
                    <FlexColumn>
                        <Caption2 color={Theme.color.secondary}>
                            Номер
                        </Caption2>
                        <ContentXsTop>
                            <InputElement
                                error={error['number']}
                                format={'### ###'}
                                mask={'_'}
                                width={'100px'}
                                value={info.number}
                                onChange={value => {
                                    if (error['number']) {
                                        dispatch(cleanError('number'))
                                    }
                                    setInfo({...info, number: value})
                                }}/>
                        </ContentXsTop>
                    </FlexColumn>
                </Gap8>
            </ContentTop>


            <ContentXsTop>
                <Caption2 color={Theme.color.secondary}>
                    Кем выдан
                </Caption2>
                <ContentXsTop>
                    <InputContainer>
                    <textarea
                        maxLength={999}
                        value={info.issued_by}
                        onChange={(e) => {
                            if (error['issued_by']) {
                                dispatch(cleanError('issued_by'))
                            }
                            setInfo({...info, issued_by: e.currentTarget.value})
                        }}>
                    </textarea>
                        <InputStringError error={error['issued_by']}>{error['issued_by']}</InputStringError>
                    </InputContainer>
                    <Caption2 color={Theme.color.secondary}>
                        Введите в точности, как указано в паспорте
                    </Caption2>
                </ContentXsTop>
            </ContentXsTop>

            <ContentTop>
                <Caption2 color={Theme.color.secondary}>
                    Код подразделения
                </Caption2>
                <ContentXsTop>
                    <InputElement
                        error={error['department_code']}
                        format={'###-###'}
                        mask={'_'}
                        value={info.department_code}
                        onChange={value => {
                            if (error['department_code']) {
                                dispatch(cleanError('department_code'))
                            }
                            setInfo({...info, department_code: value})
                        }}/>
                </ContentXsTop>
            </ContentTop>
            <FormBottomCaptionContent>
                {!error['department_code'] &&
                    <Caption2 color={Theme.color.secondary}>
                        Введите 6 цифр без дефиса
                    </Caption2>
                }
            </FormBottomCaptionContent>
            <ContentTop>
                <Caption2 color={Theme.color.secondary}>
                    Дата выдачи
                </Caption2>
                <ContentXsTop>
                    <DatePicker initDate={moment(info.issued_at).isValid() ? moment(info.issued_at) : null}
                                error={error['issued_at']}
                                onChange={(date) => {
                                    if (error['issued_at']) {
                                        dispatch(cleanError('issued_at'))
                                    }
                                    setInfo({...info, issued_at: moment(date)})
                                }}/>
                </ContentXsTop>
            </ContentTop>
        </>
    )
}
